export default __webpack_public_path__ + "static/media/bid.89abf6cf.svg";